import styled from 'styled-components';

export default styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -1;
  
  .mapboxgl-map {
    text-align: left;
  }
`;
